<template>
  <el-dialog
    v-if="dialogVisible"
    class="expansion-recharge-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="金额" prop="balance">
        <el-input v-model="dataForm.balance"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleCreateChan()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'RechargeDialog',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      orgOptions: [], //组织
      userOptions: [], //用户列表
      nodeList: [], //节点列表
      title: '充值',
      position: 'right',
      balance: null,
      dataForm: {
        balance: null,
        userId: null
      },
      editRule: {
        balance: [
          { required: true, message: '请输入充值数额', trigger: ['change', 'blur'] },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: ['change', 'blur'] }
        ]
      },
      adaptationVars: {
        formLabelWidth: 80
      }
    }
  },
  mounted() {},
  methods: {
    //充值
    handleCreateChan() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //获取form数据
          this.dataForm.balance = Number(this.dataForm.balance)
          this.$apis.expansionDemo
            .charge(this.dataForm)
            .then(res => {
              if (res) {
                this.$message.success('充值成功')
                this.$store.commit('balanceChange', this.balance + this.dataForm.balance)
                this.$emit('getBalance')
                this.handleCancel()
              }
              this.disabled = false
            })
            .catch(err => {
              this.disabled = false
            })
        } else {
          this.$message.warning('请完善信息')
          this.disabled = false
          return
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
      this.$refs.dataForm.resetFields()
    },
    handleOpen(data) {
      this.balance = data.balance
      this.dataForm = {
        balance: null,
        userId: data.id
      }
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.expansion-recharge-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item__content {
      display: flex;
    }
  }
}
</style>
